import React from "react";

const JpegCompressorTutorialSvg = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="296"
            height="100"
            fill="none"
            className="fill-[#1A1A1A] dark:fill-white scale-75  sm:scale-100"
        >
            <path d="M80.005 5H23.996C14.624 5 7 12.624 7 21.996v56.01C7 87.376 14.624 95 23.996 95h56.01C89.376 95 97 87.376 97 78.005V21.996C97 12.624 89.376 5 80.005 5ZM23.996 8.104h56.01c7.66 0 13.89 6.232 13.89 13.892V74.26L82.377 62.74a7.717 7.717 0 0 0-5.498-2.27 7.72 7.72 0 0 0-5.496 2.269L58.282 75.822l-26.15-26.15a7.688 7.688 0 0 0-5.474-2.269c-2.068 0-4.01.807-5.474 2.27L10.106 60.75V21.996c-.002-7.661 6.229-13.892 13.89-13.892ZM10.104 78.005V65.14l13.273-13.273c1.755-1.755 4.805-1.754 6.56 0l40.03 40.029h-45.97c-7.662 0-13.893-6.23-13.893-13.89Zm69.901 13.89h-5.65L60.479 78.019l13.1-13.083c1.757-1.756 4.85-1.754 6.604 0l13.683 13.682c-.323 7.374-6.406 13.279-13.86 13.279Z" />
            <path d="M52.023 38.023c5.636 0 10.22-4.585 10.22-10.22 0-5.659-4.584-10.264-10.22-10.264-5.659 0-10.264 4.604-10.264 10.265-.002 5.634 4.603 10.219 10.264 10.219Zm0-17.381c3.922 0 7.115 3.211 7.115 7.16 0 3.924-3.193 7.115-7.115 7.115-3.949 0-7.16-3.193-7.16-7.115-.002-3.947 3.212-7.16 7.16-7.16Z" />
            <g clipPath="url(#a)">
                <path d="m152.02 38-1.36 1.33 9.71 9.72H132v1.9h28.37l-9.71 9.73 1.36 1.32L164 50l-11.98-12Z" />
            </g>
            <path d="M236.235 71.885h3.485V54.092h-17.793v3.485h11.849L216.603 74.75l-.082.071 2.399 2.399.071.07 17.244-17.244v11.839ZM210.902 80.45l-2.398 2.399-.071.071 2.398 2.398.071.071 2.398-2.398.071-.07-2.398-2.4-.071-.07ZM202.793 88.54l-2.388 2.398-.071.07 2.388 2.389.071.081 2.398-2.398.071-.071-2.398-2.398-.071-.071ZM251.173 28.332h-3.486v17.803h17.793v-3.496h-11.838l17.173-17.173.071-.07-2.398-2.389-.071-.071-17.244 17.244V28.332ZM276.516 19.766l2.388-2.398.071-.072-2.388-2.388-.071-.07-2.399 2.387-.071.071 2.399 2.399.071.07ZM284.604 11.677l2.388-2.398.071-.071-2.388-2.388-.071-.071-2.398 2.388-.071.07 2.398 2.399.071.071ZM285.194 28.332v48.857c0 7.957-6.473 14.42-14.42 14.42H222.07v3.454h48.704c9.857 0 17.875-8.017 17.875-17.874V28.332h-3.455ZM265.338 8.618V5.163h-48.715c-9.857 0-17.874 8.018-17.874 17.875v48.847h3.455V23.038c0-7.957 6.473-14.42 14.419-14.42h48.715Z" />
            <defs>
                <clipPath id="a">
                    <path  d="M132 35h32v30h-32z" />
                </clipPath>
            </defs>
        </svg>
    );
    return (
        <img
            className="stroke-black dark:stroke-white"
            alt="jpeg compressor tutorial image"
            src="/images/jpeg_compres_tutorial_image.svg"
        />
    );
};

export default JpegCompressorTutorialSvg;
